import { render, staticRenderFns } from "./PassengerForm.vue?vue&type=template&id=24b27b62&"
import script from "./PassengerForm.vue?vue&type=script&lang=js&"
export * from "./PassengerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports